export default {
  'paymentGateway.title': 'Payment Gateway List',
  'paymentGateway.form.type': 'Type',
  'paymentGateway.form.type.placeholder': 'Please select type',
  'paymentGateway.form.search': 'Search',
  'paymentGateway.form.reset': 'Reset',
  'paymentGateway.operation.add': 'Add',
  'paymentGateway.operation.delete': 'Delete',
  'paymentGateway.operation.edit': 'Edit',
  'paymentGateway.operation.batchDelete': 'Batch Delete',
  'paymentGateway.operation.batchDeleteConfirm': 'Are you sure you want to delete the selected payment gateways?',
  'paymentGateway.form.status': 'Account Status',
  'paymentGateway.form.status.placeholder': 'Please select account status',
  'paymentGateway.columns.status': 'Account Status',
  'paymentGateway.status.normal': 'Normal',
  'paymentGateway.status.disabled': 'Disabled',
  'paymentGateway.status.suspended': 'Suspended',
  'paymentGateway.columns.merchantName': 'Merchant Name',
  'paymentGateway.columns.type': 'Type',
  'paymentGateway.columns.alias': 'Alias',
  'paymentGateway.columns.gatewayType': 'Gateway Type',
  'paymentGateway.columns.paymentMethod': 'Payment Method',
  'paymentGateway.columns.rotationRatio': 'Rotation Ratio',
  'paymentGateway.columns.tdsOptions': '3DS Options',
  'paymentGateway.columns.createdAt': 'Created At',
  'paymentGateway.columns.updatedAt': 'Updated At',
  'paymentGateway.columns.operations': 'Operations',
  'paymentGateway.columns.operations.view': 'View',
  'paymentGateway.modal.view': 'View Gateway',
  'paymentGateway.modal.close': 'Close',
  'paymentGateway.columns.operations.edit': 'Edit',
  'paymentGateway.columns.operations.delete': 'Delete',
  'paymentGateway.columns.operations.deleteConfirm': 'Are you sure you want to delete this record?',
  'paymentGateway.actions.refresh': 'Refresh',
  'paymentGateway.actions.density': 'Density',
  'paymentGateway.actions.columnSetting': 'Column Settings',
  'paymentGateway.size.mini': 'Mini',
  'paymentGateway.size.small': 'Small',
  'paymentGateway.size.medium': 'Medium',
  'paymentGateway.size.large': 'Large',
  'paymentGateway.type.paypal': 'Paypal',
  'paymentGateway.type.card': 'Credit Card',
  'paymentGateway.type.scard': 'Renewal Credit Card',
  'paymentGateway.type.additional': 'Local Payment',
  'paymentGateway.modal.add': 'Add Gateway',
  'paymentGateway.modal.edit': 'Edit Gateway',
  'paymentGateway.modal.createSuccess': 'Created successfully',
  'paymentGateway.modal.updateSuccess': 'Updated successfully',
  'paymentGateway.modal.saveFailed': 'Save failed',
  'paymentGateway.modal.merchantRequired': 'Please select a merchant',
  'paymentGateway.operation.deleteSuccess': 'Deleted successfully',
  'paymentGateway.operation.deleteFailed': 'Delete failed',
  'paymentGateway.operation.batchDeleteSuccess': 'Batch delete successful',
  'paymentGateway.operation.batchDeleteFailed': 'Batch delete failed',
  'paymentGateway.operation.noSelection': 'Please select data to delete first',
  'paymentGateway.verify.title': 'PayPal Config Verification',
  'paymentGateway.verify.button': 'Verify Config',
  'paymentGateway.verify.shopifyId': 'Shopify ID',
  'paymentGateway.verify.shopifyId.placeholder':
    'Enter Shopify ID (without .myshopify.com)',
  'paymentGateway.verify.shopifyId.required':
    'Please enter Shopify ID before verification',
  'paymentGateway.verify.clientId.required': 'Please enter Client ID first',
  'paymentGateway.verify.secretKey.required': 'Please enter Secret Key first',
  'paymentGateway.verify.success':
    'PayPal configuration verified. Client ID and Secret Key are valid.',
  'paymentGateway.verify.failed': 'PayPal configuration verification failed',
  'paymentGateway.verify.failedHint':
    'Verification failed. Please check Client ID, Secret Key, and Partner Id.',
  'paymentGateway.verify.failedHintNoPartner':
    'Verification failed. Please check Client ID and Secret Key.',
};
